import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { withAccessDenied, withNotifications, withRouter } from '@app/hocs'
import { withStyles } from '@app/components/styles'
import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import {
  saveActionStateDescription,
  saveActionDeviceStateInfo,
  saveActionDelay,
  saveActionDelayDescription,
  saveActionDuration,
  saveActionDurationDescription,
  saveActionDurationValueAfter,
  saveActionDeviceNumber,
} from '@app/actions/scenes/currentSceneCreating'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectVirtualSwitchActionValue
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateAction/VirtualSwitchAction/SelectVirtualSwitchActionValue/SelectVirtualSwitchActionValue'
import SelectVirtualSwitchActionValueIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateAction/VirtualSwitchAction/SelectVirtualSwitchActionValue/SelectVirtualSwitchActionValue'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? withStyles(SelectVirtualSwitchActionValueIOS) : withStyles(SelectVirtualSwitchActionValue)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { isEditActionMode, isChangeActionStateMode, initialAction } = state.scenes.currentSceneCreating
  const { actionDeviceNumber } = state.scenes.currentSceneCreating.currentAction
  const { actions } = state.scenes.currentSceneConditionsActions
  return {
    isMobile,
    isEditActionMode,
    isChangeActionStateMode,
    actionDeviceNumber,
    actions,
    initialAction,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
  saveActionStateDescription,
  saveActionDeviceStateInfo,
  saveActionDelay,
  saveActionDelayDescription,
  saveActionDuration,
  saveActionDurationDescription,
  saveActionDurationValueAfter,
  saveActionDeviceNumber,
}, dispatch)

enhance = withAccessDenied(enhance)
enhance = withNotifications(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectVirtualSwitchActionValueEnhanced = enhance

export default withRouter(SelectVirtualSwitchActionValueEnhanced)
